export const isModuloCRM = process.env.REACT_APP_MODULOS === 'CRM';
